@if (colored) {
      <svg
            [attr.height]="height"
            [attr.width]="width"
            fill="none"
            style="overflow: visible"
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" fill="#0F569E" r="31"/>
            <circle cx="32" cy="32" fill="#217DD9" r="27"/>
            <path d="M43.52 26.324V17.5431H38.48V21.0193L32 14.2002L14 33.1431H18.32V45.4002H29.48V35.3716H34.52V45.4002H45.68V33.1431H50L43.52 26.324Z"
                  fill="#FFFFFF"/>
            <defs>
            </defs>
      </svg>
} @else {
      <svg
            [attr.height]="height"
            [attr.width]="width"
            fill="none"
            style="overflow: visible"
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" fill="#424242" r="31"/>
            <circle cx="32" cy="32" fill="white" r="27"/>
            <path d="M43.52 26.324V17.5431H38.48V21.0193L32 14.2002L14 33.1431H18.32V45.4002H29.48V35.3716H34.52V45.4002H45.68V33.1431H50L43.52 26.324Z"
                  fill="#424242"/>
            <defs>
            </defs>
      </svg>
}
